export const EDITOR_VIEW_MODE = {
  SITE: 'site',
  PREVIEW: 'preview',
  EDITOR: 'editor'
};



// WEBPACK FOOTER //
// ./chat-app/constants/editor-view-mode.js